"use client";

import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
import { useState, useMemo } from "react";
import { Button } from "./ui/button";
import { useToast } from "../hooks/use-toast";
import { format } from "date-fns";
import AwesomeIcon from "../../AwesomeIcon";
import { faCopy, faDownload } from "@fortawesome/pro-light-svg-icons";
import { summarizeMeeting } from "./actions";
import useUpdateMeeting from "../hooks/useUpdateMeeting";
import { AudioController } from "./audio-controller";
import { summaryTypes } from ".";
import { useChat } from "@ai-sdk/react";
import classNames from "classnames";
import { faArrowLeft, faEllipsisVertical, faStars, faTrash } from "@fortawesome/pro-regular-svg-icons";
import DropdownMenu from "../../common/DropdownMenu";
import useDeleteMeeting from "../hooks/useDeleteMeeting";
export function SummaryDisplay(_ref) {
  var _selectedMeeting$summ, _selectedMeeting$deta6, _selectedMeeting$deta7, _selectedMeeting$deta8, _selectedMeeting$deta9;
  var selectedMeeting = _ref.selectedMeeting,
    setSelectedMeeting = _ref.setSelectedMeeting,
    onUpdateMeeting = _ref.onUpdateMeeting,
    typeOfSummary = _ref.typeOfSummary,
    setTypeOfSummary = _ref.setTypeOfSummary,
    refetchMeetings = _ref.refetchMeetings;
  var _useToast = useToast(),
    toast = _useToast.toast;
  var sections = ["Summary", "Transcript", "Ask AI"];
  var _useState = useState(sections[0]),
    activeSection = _useState[0],
    setActiveSection = _useState[1];
  var _useState2 = useState(false),
    isRegenerating = _useState2[0],
    setIsRegenerating = _useState2[1];
  var updateMeetingMutation = useUpdateMeeting();
  var deleteMeetingMutation = useDeleteMeeting();
  var meetingDate = new Date((selectedMeeting === null || selectedMeeting === void 0 ? void 0 : selectedMeeting.created_at) || "");
  var _duration = (selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$summ = selectedMeeting.summary) === null || _selectedMeeting$summ === void 0 ? void 0 : _selectedMeeting$summ.duration) || "";
  var meetingDuration = parseInt(_duration.replace(/[^\d]/g, "")) || 0;

  // Prepare meeting context for AI
  var meetingContext = useMemo(function () {
    var _selectedMeeting$deta, _selectedMeeting$deta2, _selectedMeeting$summ2, _selectedMeeting$summ3;
    if (!selectedMeeting) return "";
    var summary = (_selectedMeeting$deta = selectedMeeting.details) === null || _selectedMeeting$deta === void 0 ? void 0 : _selectedMeeting$deta.meeting_summary;
    var transcript = (_selectedMeeting$deta2 = selectedMeeting.details) === null || _selectedMeeting$deta2 === void 0 ? void 0 : _selectedMeeting$deta2.transcription;
    var context = "Meeting Title: ".concat((_selectedMeeting$summ2 = selectedMeeting.summary) === null || _selectedMeeting$summ2 === void 0 ? void 0 : _selectedMeeting$summ2.title, "\n");
    context += "Date: ".concat(selectedMeeting.created_at, "\n");
    context += "Duration: ".concat((_selectedMeeting$summ3 = selectedMeeting.summary) === null || _selectedMeeting$summ3 === void 0 ? void 0 : _selectedMeeting$summ3.duration, "\n");
    context += "\nOverview: ".concat((summary === null || summary === void 0 ? void 0 : summary.overview) || "", "\n");
    context += "\nKey Points:\n";
    if (summary !== null && summary !== void 0 && summary.topics) {
      summary.topics.forEach(function (topic, idx) {
        context += "  - ".concat(topic.title, "\n");
        if (topic.discussion_points) {
          topic.discussion_points.forEach(function (point) {
            context += "    - ".concat(point, "\n");
          });
        }
      });
    }
    context += "\nAction Items:\n";
    if (summary !== null && summary !== void 0 && summary.action_items) {
      summary.action_items.forEach(function (item) {
        context += "  - ".concat(item.description);
        if (item.owner) context += " (Owner: @".concat(item.owner, ")");
        context += "\n";
      });
    }
    context += "\nTranscript:\n".concat(transcript || "No transcript available", "\n");
    return context;
  }, [selectedMeeting]);

  // AI SDK Chatbot hook
  var _useChat = useChat({
      initialMessages: [{
        id: "system-0",
        role: "system",
        content: "You are an AI assistant. Answer questions based on the following meeting context.\n".concat(meetingContext)
      }]
    }),
    messages = _useChat.messages,
    input = _useChat.input,
    handleInputChange = _useChat.handleInputChange,
    handleSubmit = _useChat.handleSubmit,
    status = _useChat.status,
    stop = _useChat.stop,
    error = _useChat.error,
    reload = _useChat.reload;

  // Convert summary to markdown format
  var getSummaryMarkdown = function getSummaryMarkdown() {
    var _selectedMeeting$deta3, _selectedMeeting$summ4, _selectedMeeting$deta4, _selectedMeeting$deta5;
    if (!selectedMeeting) return "";
    var formattedDate = format(meetingDate, "yyyy-MM-dd HH:mm");
    var transcription = selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta3 = selectedMeeting.details) === null || _selectedMeeting$deta3 === void 0 ? void 0 : _selectedMeeting$deta3.transcription;
    return "# ".concat(selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$summ4 = selectedMeeting.summary) === null || _selectedMeeting$summ4 === void 0 ? void 0 : _selectedMeeting$summ4.title, "\n\n### _Meeting Details_\n- _Duration: ").concat(Math.floor(meetingDuration / 60), "m ").concat(meetingDuration % 60, "s_\n- _Date: ").concat(format(new Date(selectedMeeting.created_at), "MMMM d, yyyy 'at' h:mm a"), "_\n\n\n### Overview\n  ").concat(selectedMeeting === null || selectedMeeting === void 0 ? void 0 : selectedMeeting.details.meeting_summary.overview, "\n\n### Key Points\n").concat(selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta4 = selectedMeeting.details) === null || _selectedMeeting$deta4 === void 0 || (_selectedMeeting$deta4 = _selectedMeeting$deta4.meeting_summary) === null || _selectedMeeting$deta4 === void 0 ? void 0 : _selectedMeeting$deta4.topics.map(function (topic) {
      return "- ".concat(topic.title) + (topic.discussion_points && topic.discussion_points.length > 0 ? "\n" + topic.discussion_points.map(function (point) {
        return "  - ".concat(point);
      }).join("\n") : "");
    }).join("\n"), "\n\n### Action Items\n").concat(selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta5 = selectedMeeting.details) === null || _selectedMeeting$deta5 === void 0 || (_selectedMeeting$deta5 = _selectedMeeting$deta5.meeting_summary) === null || _selectedMeeting$deta5 === void 0 ? void 0 : _selectedMeeting$deta5.action_items.map(function (item) {
      return "- ".concat(item.description, " - @").concat(item.owner);
    }).join("\n"), "\n\n## Transcription\n").concat((transcription === null || transcription === void 0 ? void 0 : transcription.map(function (t) {
      return "".concat(t.speaker_id, ": ").concat(t.text);
    }).join("\n")) || "No transcript available", "\n");
  };
  var copyToClipboard = function copyToClipboard() {
    var markdownText = getSummaryMarkdown();
    navigator.clipboard.writeText(markdownText);
    toast({
      title: "Copied to clipboard",
      description: "The summary has been copied in Markdown format"
    });
  };
  var downloadSummary = function downloadSummary() {
    if (!selectedMeeting) return;
    var markdownText = getSummaryMarkdown();
    var blob = new Blob([markdownText], {
      type: "text/markdown"
    });
    var url = URL.createObjectURL(blob);
    var formattedDate = format(meetingDate, "yyyy-MM-dd-HHmm");
    var filename = "".concat(selectedMeeting === null || selectedMeeting === void 0 ? void 0 : selectedMeeting.summary.title, "-").concat(formattedDate, ".md");
    var a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast({
      title: "Summary downloaded",
      description: "The summary has been downloaded as \"".concat(filename, "\"")
    });
  };
  var regenerateSummary = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(newSummaryType) {
      var _meeting$summary, _meeting$summary2, _meeting$summary3, _newSummary$topics, _newSummary$action_it;
      var meeting,
        newSummary,
        updatePayload,
        _args = arguments;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            meeting = _args.length > 1 && _args[1] !== undefined ? _args[1] : selectedMeeting;
            if (meeting) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setIsRegenerating(true);
            // Update the summary type in context
            setTypeOfSummary(newSummaryType);
            toast({
              title: "Regenerating summary",
              description: "Regenerating summary as ".concat(newSummaryType, "...")
            });
            _context.n = 2;
            return summarizeMeeting(meeting.details.transcription, newSummaryType);
          case 2:
            newSummary = _context.v;
            if (newSummary) {
              _context.n = 3;
              break;
            }
            throw new Error("Failed to generate new summary");
          case 3:
            // Prepare the update payload
            updatePayload = {
              summary: {
                title: ((_meeting$summary = meeting.summary) === null || _meeting$summary === void 0 ? void 0 : _meeting$summary.title) || newSummary.title,
                date: ((_meeting$summary2 = meeting.summary) === null || _meeting$summary2 === void 0 ? void 0 : _meeting$summary2.date) || new Date().toISOString(),
                duration: ((_meeting$summary3 = meeting.summary) === null || _meeting$summary3 === void 0 ? void 0 : _meeting$summary3.duration) || "0m 0s",
                topics_count: ((_newSummary$topics = newSummary.topics) === null || _newSummary$topics === void 0 ? void 0 : _newSummary$topics.length) || 0,
                action_items_count: ((_newSummary$action_it = newSummary.action_items) === null || _newSummary$action_it === void 0 ? void 0 : _newSummary$action_it.length) || 0
              },
              details: {
                transcription: meeting.details.transcription,
                meeting_summary: {
                  overview: newSummary.overview || "",
                  topics: newSummary.topics || [],
                  action_items: newSummary.action_items || []
                }
              }
            };
            updateMeetingMutation.mutate({
              id: meeting === null || meeting === void 0 ? void 0 : meeting.id,
              meeting: updatePayload
            }, {
              onSuccess: function onSuccess() {
                onUpdateMeeting();
                setIsRegenerating(false);
                toast({
                  title: "Summary regenerated",
                  description: "Summary has been regenerated as ".concat(newSummaryType)
                });
              },
              onError: function onError(error) {
                console.error("Error regenerating summary:", error);
                setIsRegenerating(false);
                toast({
                  title: "Error",
                  description: error.message || "Failed to regenerate summary",
                  variant: "destructive"
                });
              }
            });
          case 4:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function regenerateSummary(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  // Only render the component when there's a meeting
  if (!selectedMeeting) {
    return null;
  }
  var confirmDelete = function confirmDelete(meeting) {
    deleteMeetingMutation.mutate(meeting.id, {
      onSuccess: function onSuccess() {
        refetchMeetings();
        setSelectedMeeting(null);
        toast({
          title: "Meeting deleted",
          description: "The meeting has been successfully deleted"
        });
      },
      onError: function onError(error) {
        console.error("Error deleting meeting:", error);
        toast({
          title: "Error",
          description: "Failed to delete the meeting",
          variant: "destructive"
        });
      }
    });
  };
  var summary = selectedMeeting.summary;
  var menuOptions = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3 p-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faCopy,
      size: "1x"
    }), "Copy Meeting summary"),
    onClick: function onClick() {
      copyToClipboard();
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3 p-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faDownload,
      size: "1x"
    }), "Download Meeting summary"),
    onClick: function onClick() {
      downloadSummary();
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center gap-3 p-3 text-red-400"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTrash,
      size: "1x"
    }), "Delete Meeting"),
    onClick: function onClick() {
      confirmDelete(selectedMeeting);
    }
  }];
  return /*#__PURE__*/React.createElement("section", {
    id: "summary-section",
    className: "\n        bg-white\n        dark:from-gray-800 dark:to-gray-900 dark:bg-gradient-to-br\n        rounded-xl border border-gray-200 dark:border-gray-800 shadow-lg overflow-hidden \n        transition-all duration-500 animate-fadeIn\n        focus-within:!shadow-lg\n        flex flex-col h-full\n      "
  }, /*#__PURE__*/React.createElement("div", {
    className: "shadow-lg flex flex-col h-full overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center px-6 pt-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-2"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "ghost",
    size: "sm",
    onClick: function onClick() {
      setSelectedMeeting(null);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowLeft,
    className: "text-gray-400 dark:text-gray-200"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-xl font-bold text-gray-900 dark:text-white"
  }, summary.title), /*#__PURE__*/React.createElement("span", {
    className: "text-gray-400 dark:text-gray-500 text-md"
  }, format(new Date(meetingDate), "MMM d, yyyy"), " \u2022", " ", Math.floor(meetingDuration / 60), "m ", meetingDuration % 60, "s")))), /*#__PURE__*/React.createElement("div", {
    className: "flex space-x-1 ml-2 mt-1 gap-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 relative "
  }, /*#__PURE__*/React.createElement("span", null, "Regenerate:"), /*#__PURE__*/React.createElement("select", {
    className: "appearance-none bg-transparent border border-gray-300 dark:border-gray-600 rounded-lg py-1 pl-3 pr-8 text-gray-700 dark:text-gray-300 hover:border-gray-400 dark:hover:border-gray-500 focus:outline-none focus:ring-1 focus:ring-teal-500",
    value: typeOfSummary,
    onChange: function onChange(e) {
      var newType = e.target.value;
      regenerateSummary(newType);
    }
  }, Object.keys(summaryTypes).map(function (type) {
    return /*#__PURE__*/React.createElement("option", {
      key: type,
      value: type
    }, summaryTypes[type]);
  }))), /*#__PURE__*/React.createElement(DropdownMenu, {
    options: menuOptions,
    menuItemClassName: "",
    buttonClassName: "border-none hover:!bg-transparent p-3",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faEllipsisVertical,
        size: "lg",
        className: "w-5 cursor-pointer"
      }));
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden justify-start p-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 rounded-t-lg"
  }, sections.map(function (section) {
    return /*#__PURE__*/React.createElement("button", {
      key: section,
      className: "text-gray-700 dark:text-gray-300 rounded-t-lg p-3 px-6 h-full hover:bg-gray-100 dark:hover:bg-gray-800 ".concat(activeSection === section ? "!bg-gray-900 text-white" : ""),
      onClick: function onClick() {
        return setActiveSection(section);
      }
    }, section === "Ask AI" && /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faStars,
      size: "lg",
      className: "mr-3 text-brand-peach"
    }), section);
  })), selectedMeeting.audio_file_url && /*#__PURE__*/React.createElement(AudioController, {
    src: selectedMeeting.audio_file_url,
    className: "ml-auto w-1/2 mb-3",
    showVolumeControl: true,
    showSkipControls: false,
    skipSeconds: 10
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full overflow-hidden"
  }, activeSection === "Summary" && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-y-auto h-full bg-white dark:bg-gray-900 rounded-b-lg rounded-tr-lg p-5 shadow-inner space-y-6 scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-bold text-gray-900 dark:text-white"
  }, "Meeting Summary")), isRegenerating ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full w-full items-center justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "animate-spin h-6 w-6 border-2 border-teal-300 border-t-teal-600 rounded-full m-3"
  }), /*#__PURE__*/React.createElement("div", null, "Generating ", summaryTypes[typeOfSummary], "...")) : /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full gap-6"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2"
  }, "\uD83D\uDD25"), " Overview:"), /*#__PURE__*/React.createElement("ul", {
    className: "space-y-2 pl-6 text-gray-700 dark:text-gray-200"
  }, selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta6 = selectedMeeting.details) === null || _selectedMeeting$deta6 === void 0 || (_selectedMeeting$deta6 = _selectedMeeting$deta6.meeting_summary) === null || _selectedMeeting$deta6 === void 0 ? void 0 : _selectedMeeting$deta6.overview)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2"
  }, "\uD83C\uDFAF"), " Key Points:"), /*#__PURE__*/React.createElement("ul", {
    className: "space-y-2 pl-6 text-gray-700 dark:text-gray-200"
  }, selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta7 = selectedMeeting.details) === null || _selectedMeeting$deta7 === void 0 || (_selectedMeeting$deta7 = _selectedMeeting$deta7.meeting_summary) === null || _selectedMeeting$deta7 === void 0 ? void 0 : _selectedMeeting$deta7.topics.map(function (point, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "list-disc"
    }, point.title, /*#__PURE__*/React.createElement("ul", {
      className: " pl-6 space-y-2 text-gray-700 dark:text-gray-200"
    }, point.discussion_points.map(function (discussion_point, index) {
      return /*#__PURE__*/React.createElement("li", {
        key: index,
        className: "text-gray-300"
      }, "- ", discussion_point);
    })));
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-lg font-semibold text-gray-900 dark:text-white mb-3 flex items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-2"
  }, "\u2705"), " Action Items:"), /*#__PURE__*/React.createElement("ul", {
    className: "list-disc pl-6 space-y-2 text-gray-700 dark:text-gray-200"
  }, selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta8 = selectedMeeting.details) === null || _selectedMeeting$deta8 === void 0 || (_selectedMeeting$deta8 = _selectedMeeting$deta8.meeting_summary) === null || _selectedMeeting$deta8 === void 0 ? void 0 : _selectedMeeting$deta8.action_items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx
    }, item.description || "", item.owner ? " - @".concat(item.owner) : "");
  }))))), activeSection === "Transcript" && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col overflow-y-auto h-full bg-white dark:bg-gray-900 rounded-lg p-5 shadow-inner space-y-6 scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-xl font-bold text-gray-900 dark:text-white"
  }, "Transcript"), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 text-gray-700 dark:text-gray-300 whitespace-pre-wrap"
  }, (selectedMeeting === null || selectedMeeting === void 0 || (_selectedMeeting$deta9 = selectedMeeting.details) === null || _selectedMeeting$deta9 === void 0 || (_selectedMeeting$deta9 = _selectedMeeting$deta9.transcription) === null || _selectedMeeting$deta9 === void 0 ? void 0 : _selectedMeeting$deta9.map(function (transcription, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx
    }, /*#__PURE__*/React.createElement("span", {
      className: "font-semibold mr-2 cursor-pointer hover:underline ".concat(["text-blue-400", "text-green-400", "text-purple-400", "text-pink-400", "text-yellow-400", "text-red-400", "text-teal-400", "text-indigo-400", "text-orange-400", "text-cyan-400"][
      // Assign a color based on speaker_id hash
      function () {
        var hash = 0;
        for (var i = 0; i < transcription.speaker_id.length; i++) {
          hash = transcription.speaker_id.charCodeAt(i) + ((hash << 5) - hash);
        }
        return Math.abs(hash) % 10;
      }()]),
      onClick: function onClick() {
        var newName = prompt("Rename speaker \"".concat(transcription.speaker_id, "\" to:"), transcription.speaker_id);
        if (newName && newName.trim() && newName !== transcription.speaker_id) {
          // Update all speaker_ids in the transcript
          var updatedTranscription = selectedMeeting.details.transcription.map(function (t) {
            return t.speaker_id === transcription.speaker_id ? _objectSpread(_objectSpread({}, t), {}, {
              speaker_id: newName
            }) : t;
          });
          // Update the meeting in state
          // (Assumes setSelectedMeeting is available in scope)
          var _selectedMeeting = _objectSpread(_objectSpread({}, selectedMeeting), {}, {
            details: _objectSpread(_objectSpread({}, selectedMeeting.details), {}, {
              transcription: updatedTranscription
            })
          });
          setSelectedMeeting(_selectedMeeting);
          setTimeout(function () {
            regenerateSummary(typeOfSummary, _selectedMeeting);
          }, 1000);
        }
      },
      title: "Click to rename speaker"
    }, transcription.speaker_id, " :"), /*#__PURE__*/React.createElement("span", null, transcription.text));
  })) || "No transcript available")), activeSection === "Ask AI" && /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full bg-white dark:bg-gray-900 rounded-lg p-5 shadow-inner scrollbar-light dark:scrollbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 flex-1 overflow-y-auto scrollbar-light dark:scrollbar bg-gray-900 rounded-lg p-3"
  }, messages && messages.length > 1 ? messages.map(function (message, idx) {
    if (message.role === "system") {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      key: message.id || idx,
      className: "mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("font-semibold", {
        "text-teal-500": message.role === "assistant",
        "text-red-500": message.role === "user"
      })
    }, message.role === "user" ? "You" : message.role === "system" ? "System" : "AI", ":"), " ", message.content);
  }) : /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full w-full items-center justify-center text-base text-gray-900 dark:text-gray-400"
  }, "Ask anything about the Meeting"), status === "submitted" && /*#__PURE__*/React.createElement("div", {
    className: "text-gray-600 animate-pulse text-md"
  }, "Thinking..."), error && /*#__PURE__*/React.createElement("div", {
    className: "text-red-500"
  }, "An error occurred.", " ", /*#__PURE__*/React.createElement("button", {
    onClick: reload,
    className: "underline"
  }, "Retry"))), /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "flex gap-2 mt-4"
  }, /*#__PURE__*/React.createElement("input", {
    className: "flex-1 rounded-lg border border-gray-300 dark:border-gray-600 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-500 bg-white dark:bg-gray-900 text-gray-900 dark:text-white",
    name: "prompt",
    value: input,
    onChange: handleInputChange,
    placeholder: "Ask any question about this meeting...",
    disabled: status !== "ready"
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    disabled: status !== "ready"
  }, "Send"), (status === "streaming" || status === "submitted") && /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: stop,
    variant: "outline"
  }, "Stop")))))));
}